"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lookupTimezoneByZip = exports.lookupTimezone = void 0;
const commons_logs_1 = require("@deliverr/commons-logs");
const tz_lookup_1 = __importDefault(require("tz-lookup"));
const zipcodes_1 = __importDefault(require("zipcodes"));
function lookupTimezone(address) {
    if (address && address.zip && address.city && address.state) {
        const zip = address.zip.includes("-") ? address.zip.split("-")[0] : address.zip;
        let point = zipcodes_1.default.lookup(zip);
        if (!point) {
            [point] = zipcodes_1.default.lookupByName(address.city, address.state);
        }
        if (!point) {
            const [neighboringZip] = zipcodes_1.default.radius(zip, 5, false);
            point = zipcodes_1.default.lookup(neighboringZip);
        }
        if (point) {
            return (0, tz_lookup_1.default)(point.latitude, point.longitude);
        }
    }
    commons_logs_1.log.error({ address }, "could not lookup timezone");
    return undefined;
}
exports.lookupTimezone = lookupTimezone;
function lookupTimezoneByZip(destinationZip) {
    const point = zipcodes_1.default.lookup(destinationZip);
    if (!point) {
        return undefined;
    }
    return (0, tz_lookup_1.default)(point.latitude, point.longitude);
}
exports.lookupTimezoneByZip = lookupTimezoneByZip;
//# sourceMappingURL=TimezoneUtils.js.map